import { gsap } from "gsap";
import { getKeyboardFocusableElements } from '../utils';

export default class Header {

    constructor() {

        this.menuOpen = false;
		this.menuAnimating = false;

		this.el = document.querySelector('[data-header]');
		this.nav = this.el.querySelector('[data-nav]');
		this.langSwitcher = this.nav.querySelector('[data-language-switcher]');
		if(this.langSwitcher) {
			this.currentLang = this.langSwitcher.getAttribute('data-language');
		}

		this.menuWrapper = this.el.querySelector('[data-menu-wrapper]');
		this.logoLink = this.el.querySelector('[data-logo-link]');
        this.logo = this.el.querySelector('[data-logo]');
        this.background = this.el.querySelector('[data-background]');
		this.hamburger = this.el.querySelector('[data-hamburger]');

		this.hamburger.addEventListener('click', () => {
			this.menuOpen ? this.close() : this.open();
		});

		window.addEventListener('close-menu', () => {
			this.close();
		});

		if(this.langSwitcher) {
			this.langSwitcher.addEventListener('click', () => {
				const languageSwitcherLang = this.langSwitcher.getAttribute('data-language');

				let newLangSwitcherLang = '';
				if(languageSwitcherLang=='en') {
					newLangSwitcherLang = 'nl';
				}
				if(languageSwitcherLang=='nl') {
					newLangSwitcherLang = 'en';
				}
				this.langSwitcher.setAttribute('data-language', newLangSwitcherLang);
			});
		}


		this.campaignBannerWrapper = document.querySelector('[data-campaign-banner-wrapper]');
		this.campaignBanner = document.querySelector('[data-campaign-banner]');

		document.addEventListener('bless', e => {
			const elm = e.detail.element;
			this.newMenu = elm.querySelector('[data-barba-menu]');

			const newLangSwitcher = this.newMenu.querySelector('[data-language-switcher]');
			if(newLangSwitcher) {
				const newLangSwitcherLang = newLangSwitcher.getAttribute('data-language');
				const newLangSwitcherUrl = newLangSwitcher.getAttribute('href');
				if(newLangSwitcherLang!=this.currentLang) {
					this.replaceMenu();
				} else {
					this.updateMenu();
				}
				this.currentLang = newLangSwitcherLang;
				this.updateLangSwitcher(newLangSwitcherLang, newLangSwitcherUrl);
			} else {
				this.updateMenu();
			}
			this.updateLogoUrl();

			// Campaign Banner
			const campaignBanner = elm.querySelector('[data-campaign-banner]');
			let mm = gsap.matchMedia();

			mm.add({
				isDesktop: "(min-width: 768px)"
			}, (context) => {
				let { isDesktop, isMobile } = context.conditions;

				if (campaignBanner) {
					if (isDesktop) {
						this.campaignBannerWrapper.appendChild(campaignBanner);
		
						gsap.set(this.el, {
							y: campaignBanner.getBoundingClientRect().height,
						});
					} else {
						gsap.set(this.el, {
							y: 0,
						});
					}
				} else {
					this.campaignBannerWrapper.innerHTML = '';
					gsap.set(this.el, {
						y: 0,
					});
				}
			});

		});


		const focusableElements = getKeyboardFocusableElements(this.nav);
		if(focusableElements.length) {
			this.firstElement = focusableElements[0];
			this.lastElement = focusableElements[focusableElements.length - 1];
		}

		window.addEventListener('keydown', e => {
			if(this.menuOpen) {
				if (e.key === 'Escape') {
					this.close();
				}

				if (e.key === 'Tab' || e.key === 9) {
					if (e.shiftKey) { /* shift + tab */
						if (document.activeElement === this.firstElement) {
							this.lastElement.focus();
							e.preventDefault();
						}
					} /* tab */ else {
						if (document.activeElement === this.lastElement) {
							this.firstElement.focus();
							e.preventDefault();
						}
					}
				}
			}
		});
    }

	replaceMenu() {
		gsap.to(this.menuWrapper, {
			opacity: 0,
			duration: 0.4,
			ease: 'power2.inOut',
			onComplete: () => {
				this.menuWrapper.innerHTML = "";
				const menuEl = this.newMenu.querySelector('.menu');
				this.menuWrapper.appendChild(menuEl);
				gsap.to(this.menuWrapper, {
					opacity: 1,
					duration: 0.4,
					ease: 'power2.inOut'
				});
			}
		});
	}

	updateMenu() {
		this.nav.querySelectorAll('li').forEach(elm => {
			elm.classList.remove('active');
		});

		const activeItem = this.newMenu.querySelector('.active');
		if(!activeItem) {
			return;
		}
		const activeItemA = activeItem.querySelector('a');
		if(!activeItemA) {
			return;
		}
		const activeItemID = activeItemA.getAttribute('data-id');
		if(!activeItemID) {
			return;
		}
		const newActiveItem = this.el.querySelector('[data-id="'+activeItemID+'"]');
		if(!newActiveItem) {
			return;
		}
		newActiveItem.setAttribute('tabindex', '-1');

		const newActiveItemLi = newActiveItem.closest('li');
		if(!newActiveItemLi) {
			return;
		}
		newActiveItemLi.classList.add('active');

	}

	updateLangSwitcher(newLangSwitcherLang, newLangSwitcherUrl) {
		if(!newLangSwitcherUrl) {
			return;
		}
		this.langSwitcher.setAttribute('href', newLangSwitcherUrl);

		if(!newLangSwitcherLang) {
			return;
		}
		this.langSwitcher.setAttribute('data-language', newLangSwitcherLang);
	}

	updateLogoUrl() {
		const newLogoUrl = this.newMenu.querySelector('[data-logo-link]').getAttribute('href');
		if(!newLogoUrl) {
			return;
		}
		this.logoLink.setAttribute('href', newLogoUrl);
	}

	open() {
		if (this.menuAnimating) {
			return;
		}
		this.menuOpen = true;

		document.body.classList.add('body--menu-visible');
        document.body.classList.add('body--menu-opening');

		this.hamburger.setAttribute('aria-expanded', true);
		this.hamburger.setAttribute('aria-label', 'close menu');

		window.dispatchEvent(new CustomEvent('disable-scroll'));

        gsap.to(this.logo, {
            translateY: '100%',
            duration: 0.6,
            delay: 0,
            ease: 'power2.inOut'
        });

        gsap.fromTo(this.background, {
            scaleY: 0,
        }, {
            scaleY: 1,
            duration: 0.75,
            delay: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                document.body.classList.add('body--menu-open');
				this.menuAnimating = true;
            }
        });

	}

	close() {
		if (!this.menuAnimating) {
			return;
		}
		this.menuOpen = false;

		document.body.classList.remove('body--menu-open');
        document.body.classList.remove('body--menu-opening');

		this.hamburger.setAttribute('aria-expanded', false);
		this.hamburger.setAttribute('aria-label', 'open menu');
		this.hamburger.focus();

		window.dispatchEvent(new CustomEvent('enable-scroll'));

        gsap.to(this.logo, {
            translateY: '0%',
            duration: 0.6,
            delay: 0,
            ease: 'power2.inOut'
        });

        gsap.fromTo(this.background, {
            scaleY: 1,
        }, {
            scaleY: 0,
            duration: 0.75,
            delay: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                document.body.classList.remove('body--menu-visible');
				this.menuAnimating = false;
            },
        });
	}

}